import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import TextInputField from "../../../components/forms/TextInputField";
import TextAreaInputField from "../../../components/forms/TextAreaInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class CreateProductForm extends Component {

  render() {
    let {errors, handleSubmit, submit, productTypes, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Type"
              name="type"
              component={DropDownInputField}
              data={productTypes}
              valueKey="type"  
              titleKey="title" 
              showBlank={true}
              serverError={this.props.errors.type}
              />          
            <Field 
              label="SKU"
              name="sku"
              component={TextInputField}
              serverError={this.props.errors.sku}
              />
            <Field 
              label="Title"
              name="title"
              component={TextInputField}
              serverError={this.props.errors.title}
              />
            <Field 
              label="Description"
              name="description"
              component={TextAreaInputField}
              serverError={this.props.errors.description}
              />
            <Field 
              label="Weight (g)"
              name="weight"
              component={TextInputField}
              normalize={numerical}
              serverError={this.props.errors.weight}
              />
            <Field 
              label="Width (mm)"
              name="width"
              component={TextInputField}
              normalize={numerical}
              serverError={this.props.errors.width}
              />
            <Field 
              label="Height (mm)"
              name="height"
              component={TextInputField}
              normalize={numerical}
              serverError={this.props.errors.height}
              />
            <Field 
              label="Depth (mm)"
              name="depth"
              component={TextInputField}
              normalize={numerical}
              serverError={this.props.errors.depth}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "CreateProductForm"
})(CreateProductForm);

export default ReduxForm;